import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';


const ParkJiSun = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "강우민♥박지선 결혼합니다.";
    const openDesc = "2025년 6월 14일 오전 11시 30분";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/136/thumb.jpg";

    const lng = 126.6599081;
    const lat = 37.3816194;

    const placeTelNum = "032-864-5500";

    const forSubway = "· 인천1호선 테크노파크역 2번 출구 (도보3분)\n· 트리플스트리트A동 ZARA 건물 좌측 단독 건물";
    const forCar = "인천 연수구 송도과학로 16번길 33-1 메리빌리아\n· 메리빌리아 주차장(트리플스트리트 'A동')\n· 트리플스트리트 'B동~D동' 주차장 이용 가능\n· 제2주차장 : 웨딩홀 건너편 송도테크노파크 IT센터 \nㅤ임시주차 가능\n\n※ 주차 무료(주차 티켓 및 도장 없이 출차 가능)";
    const forBus = "· 테크노파크역 : 16-1, 320, 81, 9, M6450, \nㅤ 303-1,4, 급행91, 급행99, 순환44 \n· 송도테크노파크 IT센터 : 1302, 9201, 303-1, 9, \nㅤ순환41 \n· 인천글로벌캠퍼스 : 16, 순환41, 순환42"
    const forRentBus = "· 시간 : 오전 7시 50분\n· 타는 곳 : 청주 체육관\n· 차량 : 우암산 고속관광\n· 인솔자 : 박용순 010-5491-8399";

    // const parents = [
    //     {groom : "명남식 · 故안인순의 아들"},
    //     {bride : "이금하 · 구은숙의 딸"}
    // ]

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #EF8DC1
    // #edacb1
    // #ff8faf
    // #e4aced
    // #aa62b5
    // #edacb1
    // #D77599
    // 빈티지 옐로우 : #EAC63C
    // 귤 : #f2a052
    // #98A74A
    const conceptStyle = {
        // spring - 빈티지 옐로우
        concept: "SPRING",
        titleColor: "#EAC63C",
        pointColor: "#EAC63C",
        btnBgColor: "#EAC63C",
        fontColor: "#ffffff",
        btnFontColor: "#313131",
        chatBgColor: "#fff9e9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }


    const infoTitle = "우리 결혼합니다.";

    const msg1 = "사람들에게 행복을 주는 그 사람을 만났습니다.";
    const msg2 = "웃는 모습이 너무나 예쁜 그 사람을 만났습니다."
    const msg3 = "그 인연에 이끌려 이제 영원을 함께 약속하려 합니다.\n이제는 서로가 서로에게 행복한 사람이 되겠습니다."


    const groomAccountList = [
        {
            role: "신랑",
            name: "강우민",
            bank: "카카오뱅크",
            accountNumber : "3333-28-2542025",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "강기호",
            bank: "국민은행",
            accountNumber : "657802-01-049965",
            isKakao :  false
        }
        ,{
            role: "신랑 모",
            name: "김기정",
            bank: "농협은행",
            accountNumber : "130022-51-215581",
            isKakao :false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박지선",
            bank: "카카오뱅크",
            accountNumber : "3333-28-2542025",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "박완순",
            bank: "중소기업은행",
            accountNumber : "341-01-560-902011",
            isKakao :false
        }
        ,{
            role: "신부 모",
            name: "김수진",
            bank: "국민은행",
            accountNumber : "221-21-0767382",
            isKakao : false
        }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "강우민",
            call: "010-7560-4109"
        }
        ,{
            role: "신랑 부",
            name: "강기호",
            call: "010-4028-0087"
        }
        ,{
            role: "신랑 모",
            name: "김기정",
            call: "010-9118-4109"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "박지선",
            call: "010-5765-0658"
        }
        ,{
            role: "신부 부",
            name: "박완순",
            call: "010-9024-6645"
        },
        {
            role: "신부 모",
            name: "김수진",
            call: "010-3393-0658"
        }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 어땠어?",
            groomAnswer: "공주두둥장",
            brideAnswer: "엄청떨렸어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "꿈속인건가",
            brideAnswer: "이제는현실"
        },
        {
            question : "결혼을 결심한 이유가 뭐야?",
            groomAnswer: "같이있을때",
            brideAnswer: "가장즐거워"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "밥은안굶겨",
            brideAnswer: "내조의여왕"
        },
        {
            question : "마지막으로 서로에게 하고 싶은 말은?",
            groomAnswer: "잘살아봅세",
            brideAnswer: "많이사랑해"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#EAC63C"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.brideNameEn)} brideNameEn={toUpperCaseString(weddingData.groomNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} />
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forRentBus={forRentBus} forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkJiSun;